import { render, staticRenderFns } from "./chateau-cos-destournel.vue?vue&type=template&id=410fa27c&scoped=true"
import script from "./chateau-cos-destournel.vue?vue&type=script&lang=js"
export * from "./chateau-cos-destournel.vue?vue&type=script&lang=js"
import style0 from "./chateau-cos-destournel.vue?vue&type=style&index=0&id=410fa27c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410fa27c",
  null
  
)

export default component.exports